// ---------------------------------------------------------------- Imports ----------------------------------------------------------------

import gsap from "gsap";
import { useEffect, useState } from "react";
import { toast, Toaster } from "react-hot-toast";
import logo1 from "../assets/images/logo1.png";
import logo2 from "../assets/images/logo2.png";
import logo3 from "../assets/images/logo3.png";
import logo4 from "../assets/images/logo4.png";

import { Formik, Form, Field, ErrorMessage } from "formik";
import { contactUsInitialValues } from "../formik/initialValues/ContactUsInitialValues";
import { contactUsValidationSchema } from "../formik/validations/contactUsValidationSchema";

const ContactUs = () => {
  // ---------------------------------------------------------------- State: Form Data ----------------------------------------------------------------

  // const [formData, setFormData] = useState({
  //   fullName: "",
  //   emailId: "",
  //   country: "",
  //   phoneNo: "",
  //   message: "",
  // });

  // ---------------------------------------------------------------- Animation: Button Hover Enter ----------------------------------------------------------------

  const handleMouseEnter = (e) => {
    const button = e.currentTarget;
    const visibleSpan = button.querySelector(".btn1");
    const hiddenSpan = button.querySelector(".btn2");

    gsap.to(visibleSpan, {
      duration: 1,
      y: -100,
      ease: "power2.inOut",
    });
    gsap.to(hiddenSpan, {
      duration: 1.5,
      y: -50,
      ease: "power2.inOut",
      opacity: 1,
    });
  };

  // ---------------------------------------------------------------- Animation: Button Hover Leave ----------------------------------------------------------------

  const handleMouseLeave = (e) => {
    const button = e.currentTarget;
    const visibleSpan = button.querySelector(".btn1");
    const hiddenSpan = button.querySelector(".btn2");

    gsap.to(visibleSpan, {
      duration: 0.5,
      y: 0,
      ease: "power2.inOut",
    });
    gsap.to(hiddenSpan, {
      duration: 1,
      y: 0,
      ease: "power2.inOut",
      opacity: 0,
    });
  };

  // ---------------------------------------------------------------- Animation: Paragraph Scroll In ----------------------------------------------------------------

  useEffect(() => {
    gsap.fromTo(
      ".paragraph",
      {
        opacity: 0,
        duration: 1,
        ease: "power2.inOut",
      },
      {
        opacity: 1,
        duration: 2,
        ease: "power2.inOut",
        scrollTrigger: {
          trigger: ".paragraph",
          start: "top 50%",
        },
      }
    );
  });

  // ---------------------------------------------------------------- Handler: Input Change ----------------------------------------------------------------

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  // ---------------------------------------------------------------- Handler: Form Submit ----------------------------------------------------------------

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (
  //     !formData.fullName ||
  //     !formData.emailId ||
  //     !formData.country ||
  //     !formData.phoneNo ||
  //     !formData.message
  //   ) {
  //     toast.error("Please fill in all fields!");
  //     return;
  //   }
  //   try {
  //     const payload = {
  //       name: formData.fullName,
  //       email: formData.emailId,
  //       message: formData.message,
  //       phone_number: formData.phoneNo,
  //       country: formData.country,
  //     };
  //     const res = await fetch(
  //       "https://6aply0b2jk.execute-api.ap-south-1.amazonaws.com/default/paramgroups_contact_us",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //       }
  //     );
  //     if (!res.ok) {
  //       throw new Error("Network response was not ok");
  //     }
  //     const result = await res.json();
  //     setFormData({
  //       fullName: "",
  //       emailId: "",
  //       country: "",
  //       phoneNo: "",
  //       message: "",
  //     });
  //     toast.success("Message Sent Successfully!");
  //   } catch (error) {
  //     toast.error("Error sending your message!");
  //   }
  // };

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const payload = {
        name: values.fullName,
        email: values.emailId,
        message: values.message,
        phone_number: values.phoneNo,
        country: values.country,
      };

      const res = await fetch(
        "https://6aply0b2jk.execute-api.ap-south-1.amazonaws.com/default/paramgroups_contact_us",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Network error");

      // Save to Live Excel (Google Sheets)
      try {
        await fetch(
          "https://script.google.com/macros/s/AKfycbzZqwnsEGIpHOuBlYSdzXuJ6hbJ6byBr_1epGiL2nMeOZEFvwlYdvz2OH-ogXby78wsqA/exec",
          {
            method: "POST",
            headers: { "Content-Type": "text/plain;charset=utf-8" },
            body: JSON.stringify(payload),
          }
        );
      } catch (googleErr) {
        console.error("Error saving to Google Sheets:", googleErr);
      }

      toast.success("Message Sent Successfully!");
      resetForm();
    } catch (err) {
      toast.error("Error sending your message!");
    }
  };


  return (
    <>
      <Toaster />
      <div className="w-full flex flex-col gap-[10px] mt-20 lg:mb-[160px] md:mb-[128px] xs:mb-[53px]  -z-50 ">
        <div className="flex flex-col lg:gap-[60px] md:gap-[80px] xs:gap-[30px]">
          <div className="flex flex-col lg:gap-[75px] md:gap-[53px] xs:gap-[50px]">
            <div className="w-full px-4 lg:px-10 flex flex-col lg:flex-row md:items-start xs:items-center lg:-space-y-12 lg:space-x-4">
              <div className="flex justify-center lg:justify-start w-full">
                <p className="line-1 2xl:text-[72px] lg:text-[clamp(50px,5vw,72px)] xs:text-[clamp(39px,4.9vw,50px)] font-faustina font-bold bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] text-transparent bg-clip-text tracking-widest text-center">
                  Connect With Us
                </p>
              </div>
              <div className="flex justify-center xl:mb-2 w-full text-border font-faustina font-medium  2xl:text-[70px] lg:text-[clamp(48px,4.5vw,70px)] xs:text-[clamp(40px,4.8vw,48px)]  opacity-40 text-[#00000080]">
                "Let's Start A Project Together"
              </div>
            </div>
            <div className="relative flex w-full h-full justify-center items-center">
              <div className="hidden md:flex gradient-box absolute md:h-[37%] xl:h-[28%]   lg:top-[33%] md:top-[33%] xl:top-[36%] w-full bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-sky-300 z-[-1]"></div>
              <div className="grid lg:grid-cols-2 md:grid-cols-2  xs:grid-cols-1 xl:grid-cols-3 sm:grid-cols-1 w-[90%] h-full xs:gap-7 gap-[60px] ">
                <div className="flex flex-col justify-center items-center bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] h-auto rounded-[25px] gap-8 p-1 self-stretch xl:mx-auto lg:mx-auto  md:mx-auto">
                  <div className="flex flex-col bg-black rounded-[25px] h-full w-full gap-8 xs:px-4 xs:py-5 px-[25px] py-[32px]">
                    <p className="font-faustina font-semibold bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] text-transparent bg-clip-text  lg:text-[32px] xs:text-[clamp(24px,3.2vw,32px)] ">
                      Param Group of Companies - INDIA
                    </p>
                    <div className="flex flex-col  xs:gap-5  gap-8 text-white">
                      <div className="flex gap-8  xs:gap-4 items-center">
                        <img
                          src={logo1}
                          alt="img"
                          className="object-contain xs:w-4 sm:w-5 md:w-5 lg:w-6"
                        />
                        <p className="font-faustina lg:text-[24px] xs:text-[clamp(16px,2.4vw,24px)] font-normal">
                          +91 701 669 3717
                        </p>
                      </div>
                      {/* <div className="flex gap-8 items-center">
                      <img
                        src={logo2}
                        alt="img"
                        className="object-contain  xs:w-5 sm:w-6 md:w-6 lg:w-8"
                      />
                      <p className="font-faustina text-[24px] xs:text-[16px] sm:text-[20px] font-normal">
                        +91 265 2466950
                      </p>
                    </div> */}
                      <div className="flex  xs:gap-4 gap-8 items-center">
                        <img
                          src={logo3}
                          alt="img"
                          className="object-contain xs:w-4 sm:w-5 md:w-5 lg:w-6"
                        />
                        <p className="font-faustina lg:text-[24px] xs:text-[clamp(16px,2.4vw,24px)] font-normal">
                          info@paramgroups.com
                        </p>
                      </div>
                      <div className="flex  xs:gap-4 gap-8 items-center">
                        <img
                          src={logo4}
                          alt="img"
                          className="object-contain xs:w-4 sm:w-5 md:w-5 lg:w-6"
                        />
                        <p className="font-faustina lg:text-[24px] xs:text-[clamp(16px,2.4vw,24px)] font-normal">
                          707 - 710 Everest Onyx, Opp Inox Multiplex, Race
                          Course Rd, Vadodara - 390021
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col justify-center items-center bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] h-auto rounded-[25px] gap-8 p-1 self-stretch lg:mx-auto  md:mx-auto">
                  <div className="flex flex-col bg-black rounded-[25px] h-full w-full gap-8 xs:px-4 xs:py-5 px-[25px] py-[32px]">
                    <p className="font-faustina font-semibold bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] text-transparent bg-clip-text lg:text-[32px] xs:text-[clamp(24px,3.2vw,32px)]">
                      Param Group of Companies Headquarter - USA
                    </p>
                    <div className="flex flex-col  xs:gap-5 gap-8 text-white">
                      <div className="flex   xs:gap-4 gap-8 items-center ">
                        <img
                          src={logo1}
                          alt="img"
                          className="object-contain xs:w-4 sm:w-5 md:w-5 lg:w-6"
                        />
                        <p className="font-faustina lg:text-[24px] xs:text-[clamp(16px,2.4vw,24px)] font-normal">
                          +1 732 404 0466
                        </p>
                      </div>
                      <div className="flex gap-8  xs:gap-4 items-center">
                        <img
                          src={logo2}
                          alt="img"
                          className="object-contain xs:w-5 sm:w-5 md:w-5 lg:w-6"
                        />
                        <p className="font-faustina lg:text-[24px] xs:text-[clamp(16px,2.4vw,24px)] font-normal">
                          +1 732 404 0422
                        </p>
                      </div>
                      <div className="flex  xs:gap-4 gap-8 items-center">
                        <img
                          src={logo3}
                          alt="img"
                          className="object-contain xs:w-4 sm:w-5 md:w-5 lg:w-6"
                        />
                        <p className="font-faustina lg:text-[24px] xs:text-[clamp(16px,2.4vw,24px)] font-normal">
                          info@pcsionweb.com
                        </p>
                      </div>
                      <div className="flex xs:gap-4 gap-8 items-center">
                        <img
                          src={logo4}
                          alt="img"
                          className="object-contain xs:w-4 sm:w-5 md:w-5 lg:w-6"
                        />
                        <p className="font-faustina lg:text-[24px] xs:text-[clamp(16px,2.4vw,24px)] font-normal">
                          200 Middlesex Essex TPK., Suite 110, Iselin, NJ, 08830
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col justify-center items-center bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] h-auto rounded-[25px] gap-8 p-1 self-stretch md:col-span-2 lg:col-span-2 xl:col-span-1  lg:mx-auto  md:mx-auto">
                  <div className="flex flex-col bg-black rounded-[25px] h-full w-full gap-8 xs:px-4 xs:py-5 px-[25px] py-[32px]">
                    <p className="font-faustina font-semibold bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] text-transparent bg-clip-text  lg:text-[32px] xs:text-[clamp(24px,3.2vw,32px)]">
                      Param Group of Companies - CANADA
                    </p>
                    <div className="flex flex-col gap-8  xs:gap-5 text-white">
                      <div className="flex gap-8  xs:gap-4 items-center">
                        <img
                          src={logo1}
                          alt="img"
                          className="object-contain xs:w-4 sm:w-5 md:w-5 lg:w-6"
                        />
                        <p className="font-faustina lg:text-[24px] xs:text-[clamp(16px,2.4vw,24px)] font-normal">
                          +1 647 833 7205
                        </p>
                      </div>
                      <div className="flex gap-8  xs:gap-4 items-center">
                        <img
                          src={logo2}
                          alt="img"
                          className="object-contain xs:w-4 sm:w-5 md:w-5 lg:w-6"
                        />
                        <p className="font-faustina lg:text-[24px] xs:text-[clamp(16px,2.4vw,24px)] font-normal">
                          +1 905 604 0647
                        </p>
                      </div>
                      {/* <div className="flex gap-8  xs:gap-4 items-center">
                        <img src={logo2} alt="img" className="object-contain xs:w-5 sm:w-5 md:w-5 lg:w-6" />
                        <p className="font-faustina lg:text-[24px] xs:text-[clamp(16px,2.4vw,24px)] font-normal">+1 905 604 0647</p>
                      </div> */}
                      <div className="flex gap-8  xs:gap-4 items-center">
                        <img
                          src={logo3}
                          alt="img"
                          className="object-contain xs:w-4 sm:w-5 md:w-5 lg:w-6"
                        />
                        <p className="font-faustina lg:text-[24px] xs:text-[clamp(16px,2.4vw,24px)] font-normal">
                          info@pcsionweb.com
                        </p>
                      </div>
                      <div className="flex gap-8  xs:gap-4 items-center">
                        <img
                          src={logo4}
                          alt="img"
                          className="object-contain xs:w-4 sm:w-5 md:w-5 lg:w-6"
                        />
                        <p className="font-faustina lg:text-[24px] xs:text-[clamp(16px,2.4vw,24px)] font-normal">
                          84 Redkey DR. , Markham, Ontario Canada, L3S 4R6
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col  h-full w-full justify-center items-center lg:gap-[78px] md:gap-[74px] xs:gap-[41px]">
            <div className="flex justify-center items-center">
              <p className=" paragraph flex  text=center items-center font-faustina font-semibold bg-gradient-to-r from-[#1FA2FF] from-0% via-[#12D8FA] via-50% to-[#A6FFCB]  to-80% text-transparent bg-clip-text lg:text-[56px] xs:text-[clamp(30px,6.9vw,56px)]">
                Send Us a Message
              </p>
            </div>
            <div className="flex w-[90%] xs:flex-col-reverse md:flex-row  md:w-[90%]   xs:w-full  lg:gap-[165px] 900:gap-[100px] md:gap-[38px] xs:gap-[32px] justify-center items-center">
              <Formik
                initialValues={contactUsInitialValues}
                validationSchema={contactUsValidationSchema}
                onSubmit={handleSubmit}
              >
                {({ handleSubmit }) => (
                  <Form className="  md:w-[50%] xs:w-[90%]  flex flex-col  gap-6">
                    <div className="flex flex-col gap-2">
                      <div className="flex bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB]  w-full h-auto rounded-[5px] p-0.5 self-stretch">
                        <Field
                          type="text"
                          name="fullName"
                          // value={formData.fullName}
                          // onChange={handleChange}
                          className="bg-black w-full rounded-[5px] font-poppins text-[14px] font-normal text-[#CAC4C4] pl-[16px] py-[9px] self-stretch"
                          placeholder="Full Name"
                        />
                      </div>
                      <ErrorMessage
                        name="fullName"
                        component="div"
                        className="text-red-400 text-sm"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <div className="flex bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB]  w-full h-auto rounded-[5px] p-0.5 self-stretch">
                        <Field
                          name="emailId"
                          type="email"
                          className="bg-black w-full rounded-[5px] font-poppins text-[14px] font-normal text-[#CAC4C4] pl-[16px] py-[9px]"
                          placeholder="Email ID"
                          // value={formData.emailId}
                          // onChange={handleChange}
                        />
                      </div>
                      <ErrorMessage
                        name="emailId"
                        component="div"
                        className="text-red-400 text-sm"
                      />
                    </div>
                    <div className="flex lg:flex-row xs:flex-col gap-[20px]">
                      <div className="w-full flex flex-col gap-2">
                        <div className="flex bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] w-[100%] h-auto rounded-[5px] p-0.5 self-stretch">
                          <Field
                            as="select"
                            name="country"
                            id="Country"
                            // value={formData.country}
                            // onChange={handleChange}
                            className="w-[100%] bg-black rounded-[5px] font-poppins text-[14px] font-normal text-[#CAC4C4] pl-[16px] py-[9px]"
                          >
                            <option value="">Select Country</option>
                            <option value="India">India</option>
                            <option value="US">US</option>
                          </Field>
                        </div>
                        <ErrorMessage
                          name="country"
                          component="div"
                          className="text-red-400 text-sm"
                        />
                      </div>
                      <div className="w-full flex flex-col gap-2">
                        <div className="flex bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB]  w-full h-auto rounded-[5px] p-0.5 self-stretch">
                          <Field
                            type="tel"
                            name="phoneNo"
                            maxLength={10}
                            // value={formData.phoneNo}
                            // onChange={handleChange}
                            className="bg-black w-full rounded-[5px] font-poppins text-[14px] font-normal text-[#CAC4C4] pl-[16px] py-[9px]"
                            placeholder="Phone"
                          />
                        </div>
                        <ErrorMessage
                          name="phoneNo"
                          component="div"
                          className="text-red-400 text-sm"
                        />
                      </div>
                    </div>
                    <div className="flex flex-col gap-2">
                      <div className="flex bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB]  w-full h-auto rounded-[5px] p-0.5 self-stretch">
                        <Field
                          as="textarea"
                          name="message"
                          id="message"
                          // value={formData.message}
                          // onChange={handleChange}
                          className="bg-black w-full h-[110px] rounded-[5px] font-poppins text-[14px] font-normal text-[#CAC4C4] pl-[16px] py-[9px] self-stretch"
                          placeholder="Your Message"
                        ></Field>
                      </div>
                      <ErrorMessage
                        name="message"
                        component="div"
                        className="text-red-400 text-sm"
                      />
                    </div>
                    <div className="flex justify-center items-center w-[130px] h-[50px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[14px] bg-transparent p-0.5">
                      <button
                        className="button-main bg-black w-full h-full rounded-[14px]  font-poppins font-medium md:text-[20px] xs:text-[18px] diagonal text-center relative py-[16px] px-[40px]"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        onClick={handleSubmit}
                      >
                        <span className="btn1 absolute transition-all top-[1px] left-0 w-full h-full flex justify-center items-center text-white">
                          SEND
                        </span>
                        <span className="btn2 absolute tranistion-all opacity-0 top-[52px] left-0 w-full h-full flex justify-center items-center text-white">
                          SEND
                        </span>
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
              <div className="flex md:w-[50%] xs:w-[90%] rounded-[15px]">
                <div className="rounded-[15px] h-full w-full">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29528.443383203376!2d73.12096057431638!3d22.313743600000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x49fb8a803f41fa9%3A0xa349bba25c4ea4dc!2sParam%20Group%20of%20Companies!5e0!3m2!1sen!2sin!4v1735039444947!5m2!1sen!2sin"
                    className="w-full h-[600PX] rounded-[20px] "
                    allowfullscreen=""
                    loading="lazy"
                    title="iframe"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
